/* eslint-disable no-return-assign */
import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_IS_OPEN_MODAL_ORDER_INFO: 'SET_IS_OPEN_MODAL_ORDER_INFO',
};
export const workerAllocateMutationType = vuexEventPathGenerator(mutationType, 'modalOrderInfo');
const mutations = {
    [mutationType.SET_IS_OPEN_MODAL_ORDER_INFO](state, orderId) {
        state.isOpenModalOrderInfo = orderId;
    },
};
export default mutations;
